let standardCrud = {
    read: {
        params: { action: 'get' }
    },
    create: {
        params: { action: 'create' }
    },
    update: {
        params: { action: 'update' }
    },
    destroy: {
        params: { action: 'delete' }
    }
}

export default {
    scheduleDate: {
        defaults: {
            endpoint: 'scheduleDate.php',
            rootProperty: 'schedule_date'
        },
        ...standardCrud
    }
}